<template>
  <div>
    <div>
			<span class="xbed-sub-title">修改房间通电状态</span>
		</div>
		<div class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>管理员权限</BreadcrumbItem>
				<BreadcrumbItem>修改房间通电状态</BreadcrumbItem>
			</Breadcrumb>
		</div>
    <br>
    <div style="min-height: 500px">
      <Form @submit.native.prevent="preventSubmit" :rules="editRoomStatusRules" ref="editRoomStatusForm">
        <FormItem label="房间ID：" prop="query.roomId" :label-width="95">
          <Input type="text" v-model="query.roomId" style="width:500px"></Input>
        </FormItem>
        <FormItem label="订单号：" prop="query.orderNo" :label-width="95">
          <Input type="text" v-model="query.orderNo" style="width:500px"></Input>
        </FormItem>
        <FormItem label="入住单：" prop="query.checkinId" :label-width="95">
          <Input type="text" v-model="query.checkinId" style="width:500px"></Input>
        </FormItem>
        <FormItem label="清洁单号：" prop="query.cleanOrderNo" :label-width="95">
          <Input type="text" v-model="query.cleanOrderNo" style="width:500px"></Input>
        </FormItem>
        <FormItem label='目标状态：' :label-width='95' prop="query.roomStatus">
          <Select v-model="query.roomStatus" placeholder="请选择" style="width:500px" filterable>
            <Option v-for="(powerType, index) in powerObject" :key="index" :value="index">{{powerType.roomStatText}}</Option>
          </Select>
        </FormItem>
        <FormItem label="备注：" prop="query.remark" :label-width="95">
          <Input type="textarea" :autosize="{minRows: 3,maxRows: 5}" v-model="query.remark" style="width:500px"></Input>
        </FormItem>
        <FormItem :label-width='95'>
          <Button type="primary" style="width:500px" @click="sendBtn" :loading='sendLoading'>发送</Button>
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import Moment from "moment"
import Utils from "@/utils";
import API from "@/api";
export default {
  async created() {
    this.query = {
      roomId: Utils.getUrlParameterByName( 'roomId' )
    }
    this.token = Utils.findFromLocalStorage( "vue-token" );
    this.username = Utils.findFromLocalStorage( "vue-username" );
    this.userId = Utils.findFromLocalStorage( "vue-userid" );
    this.env = Utils.findFromLocalStorage( "env", "dev" );

    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'isForm': true,
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
    }
	},
  data () {
    const validateList = {
      roomId: ( rule, value, callback ) => {
        console.log("roomId", !this.query.roomId)
				if ( !this.query.roomId) {
					callback( new Error( '房间ID不能为空' ) )
				} else {
					callback();
				}
			},
      roomStatus: ( rule, value, callback ) => {
				if ( !this.query.roomStatus ) {
					callback( new Error( '目标状态能为空' ) )
				} else {
					callback();
				}
			},
    }
    return {
      creatTime:[
        Moment().subtract( 0, 'day' ).format( 'YYYY-MM-DD' ),
				Moment().format( 'YYYY-MM-DD' )
      ],
      sendLoading:false,
      query:{
        roomId:'',
        remark:'',
        roomStatus:0
      },
      powerObject: {
        "1": {statusType: 1, powerStatus: 1, roomStatText:"清洁通电"},
        "2": {statusType: 1, powerStatus: 0, roomStatText:"清洁断电"},
        "3": {statusType: 2, powerStatus: 1, roomStatText:"维修通电"},
        "4": {statusType: 2, powerStatus: 0, roomStatText:"维修断电"},
        "5": {statusType: 3, powerStatus: 1, roomStatText:"入住通电"},
        "6": {statusType: 4, powerStatus: 1, roomStatText:"退房断电"},
        "7": {statusType: 5, powerStatus: 0, roomStatText:"拔卡断电"},
        "8": {statusType: 5, powerStatus: 1, roomStatText:"插卡通电"},
      },
      editRoomStatusRules:{
        roomId: [
					{required: true, validator: validateList.roomId, trigger: 'blur'}
				],
        remark: [
          { required: true, message: '必须填写' }
        ],
        roomStatus: [
					{required: true, validator: validateList.roomStatus, trigger: 'change'}
				],
      }
    }
  },
  mounted() {
		this.$Notice.config( {
			top: 200
		});
	},
  methods: {
    async sendBtn(){
      let validResult = false
      this.$refs.editRoomStatusForm.validate(valid =>{
         validResult = valid
      })
      console.log("validResult", validResult)
      if ( !validResult ) {
				return;
      }
      // let roomId = this.query.roomId.replace(/\s*/g,"").split(",")
      // for(let i=0;i < roomId.length;i++){
      if (this.query.roomId.length > 11 || this.query.roomId.length == 0) {
        this.$Notice.error({
          title: "房间ID错误"
        });
        return
      }
      if (!this.query.roomStatus) {
        this.$Notice.error({
          title: "请选择目标状态"
        });
        return
      }
      // }
      let params = {
        operator:"【OMS】" + this.username,
        remark:  "【"+ this.powerObject[this.query.roomStatus].roomStatText +"】" + this.query.remark,
        powerStatus: this.powerObject[this.query.roomStatus].powerStatus,
        statusType: this.powerObject[this.query.roomStatus].statusType,
        roomId:this.query.roomId
      }
      if(this.query.orderNo){
        params.orderNo = this.query.orderNo
      }
      if(this.query.cleanOrderNo){
        params.cleanOrderNo = this.query.cleanOrderNo
      }
      if(this.query.checkinId){
        params.checkinId = this.query.checkinId
      }
      this.sendLoading = true
      let resp = (await API.omsAPI[this.env].clientServer.updateHotelRoomState(params, this.protHeaders)).data
      this.sendLoading = false
      if (resp.retCode) {
        this.$Notice.error({
          title: "修改失败",
          desc: resp.msg
        });
        return
      }
      this.$Notice.success({
        title: "修改成功",
        desc: resp.msg
      });
      this.query = {
        roomId:'',
        roomStatus:0
      }
      this.creatTime = [Moment().subtract( 0, 'day' ).format( 'YYYY-MM-DD' ),Moment().format( 'YYYY-MM-DD' )]
    },
    preventSubmit(){
      return false
    }
  },
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/pages/room/editRoomElecStatus.vue